module.exports = __webpack_public_path__ + "img/评论2_03.545c652d.jpg";